import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useNutritionistHubTracker } from '@src/screens/NutritionistHub/hooks'
import { CustomEventTypes } from '@src/config/analytics'
import { appointmentKindSelector } from '@src/selectors/app'
import { EhrAppointmentCustomType } from '@src/screens/NutritionistHub/utils'
import { CalendarIcon } from './CalendarIcon'
import { CardProps } from './types'
import { Card } from './Card'
import { AppointmentPaymentMethodChip } from './AppointmentPaymentMethodChip'
import { AppointmentBody } from './AppointmentBody'

interface UpcomingCallCardProps extends CardProps {
  appointment: EhrAppointmentCustomType
}

export const UpcomingCallCard = ({ appointment, ...props }: UpcomingCallCardProps) => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation()
  const track = useNutritionistHubTracker()

  const { kind, providerName: coachName, meetingAt } = appointment
  const appointmentKind = useSelector(appointmentKindSelector(kind))
  const coachingKind = appointmentKind?.coachingKind
  const chargeKind = appointment.attendances[0].chargeKind

  const serviceTitle = coachingKind?.serviceTitle || 'Coaching'
  const title = `${serviceTitle} Call`
  const duration = appointmentKind?.duration ?? '0'

  const onCardPress = () => {
    track(CustomEventTypes.NutritionistHubViewCallDetailsTapped)
    navigation.navigate('VideoCallModal', { id: appointment.id })
  }

  return (
    <Card
      {...props}
      icon={<CalendarIcon variant="date" date={meetingAt} />}
      title={title}
      description="$0 out of pocket with most insurance. You won't be charged."
      body={<AppointmentBody coachName={coachName} meetingAt={meetingAt} duration={duration} />}
      buttonTitle="Book your next call"
      badgeAccessory={
        <AppointmentPaymentMethodChip
          lastStateKind={appointment.lastState.kind}
          chargeKind={chargeKind}
          style={styles.chip}
        />
      }
      onCardPress={onCardPress}
    />
  )
}

const themedStyles = StyleService.create({
  chip: {
    top: -3,
  },
})
